import { LoadingOrError } from '@retainerclub/common';
import { useReferral } from '@retainerclub/hooks';
import OnboardingLayout from '../../layouts/OnboardingLayout/OnboardingLayout';

function Onboarding() {
  const { rLoading, rError, pLoading, pError } = useReferral();

  const shouldRender = LoadingOrError({
    loading: rLoading || pLoading,
    error: rError || pError,
    title: 'Your Information',
    shouldShowError: rError || pError,
  });

  if (shouldRender) {
    return <OnboardingLayout />;
  }

  return shouldRender;
}

export default Onboarding;
